import Alpine from 'alpinejs'
import Swiper, {
    Navigation,
    Pagination,
    Thumbs,
    EffectFade,
    Mousewheel,
    FreeMode,
    Autoplay,
    Keyboard,
  } from "swiper";
  
  import "swiper/css";
  
  import "swiper/css/pagination";
  import "swiper/css/effect-fade";
  
  Swiper.use([Autoplay, Pagination, Navigation, Thumbs, EffectFade, Mousewheel, FreeMode, Keyboard]);
  window.Swiper = Swiper;
window.Alpine = Alpine

Alpine.start()

const header = document.getElementById("bgheader");

// Add an event listener to the window to detect scrolling
window.addEventListener("scroll", function () {
    // Check if the page has been scrolled down
    if (window.scrollY > 0) {
        // Add the "scroll" class to the header
        header.classList.add("headerscrolled");
    } else {
        // Remove the "scroll" class when the page is at the top
        header.classList.remove("headerscrolled");
    }
});


    let bodysimple = document.querySelector('.page-template-simple-page');

    if(bodysimple != null) {
        let homeurl = window.location.origin;
        let linkElements = document.querySelectorAll('.ancora');
        
        
        linkElements.forEach(function (linkElement) {
            let linkValue = linkElement.getAttribute('href');
            if (linkValue) {
                linkElement.setAttribute('href', homeurl + linkValue);
            }
        });
    }
    

    
    

   



